/* eslint-disable react-hooks/exhaustive-deps */

import {useMutation, useQuery} from "@apollo/react-hooks";
import {makeStyles} from '@material-ui/core/styles';
import React, {useCallback, useEffect, useState} from 'react';
import {
    CREATE_EMAIL_ADDRESS,
    DELETE_EMAIL_ADDRESS,
    GET_EMAIL_ADDRESSES_OF_PARENT,
    UPDATE_EMAIL_ADDRESS
} from "../../database/queries/emailAddressQueries";
import MaterialTable, {MTableEditField} from "material-table";
import moment from "moment";
import tableIcons from "../../constants/tableIcons";
import {SizeMe} from "react-sizeme";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import ChooseFromChoices from "../Common/chooseFromChoices";
import {EMAIL_ADDRESS_TYPE_CHOICES} from "../../database/queries/enumQueries";
import usePersistentStore from "../../persistentStore";
import {simulateMouseClick} from "../../utils/utils";
import TextField from "@material-ui/core/TextField";
import {CREATE_WEB_HISTORY} from "../../database/queries/webHistoryQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    navigation: {
        marginBottom: 0,
    },
    iFrameNavigation: {
        marginBottom: 0,
        minHeight: 0,
    },
    toolbar: {
        marginBottom: 0
    },
    iFrameToolbar: {
        marginBottom: 0,
        minHeight: 0
    },
    grow: {
        flexGrow: 1,
    },
    table: {
        '& .MuiTypography-root': {
            fontSize: '1rem',
        },
    },
    '& #email-address-table .MuiTableCell-body': {
        paddingLeft: 8,
        paddingRight: 8
    },
    '& #email-address-table .MuiTableCell-sizeSmall': {
        paddingLeft: 8,
        paddingRight: 8
    },
    emailOK: {},
    emailNotOK: {
        '& input': {
            color: 'red',
        }
    }
}));

const PopupEmailAddresses = props => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();
    const [globalPersistentState] = usePersistentStore();
    const [emailAddresses, setEmailAddresses] = useState([]);
    const [emailAddress, setEmailAddress] = useState();
    const [emailAddressType, setEmailAddressType] = useState('work');

    const {loading: getEmailAddressesOfParentLoading, error: getEmailAddressesOfParentError, data: getEmailAddressesOfParentData, refetch: getEmailAddressesOfParentRefetch} = useQuery(GET_EMAIL_ADDRESSES_OF_PARENT, {
        skip: !props.editId || props.editId === 'new',
        variables: {
            parentType: props.editType,
            parentId: props.editId,
            orderList: ['emailAddress ASC']
        },
    });

    const [createEmailAddress, {error: createEmailAddressError}] = useMutation(CREATE_EMAIL_ADDRESS);
    const [updateEmailAddress, {error: updateEmailAddressError}] = useMutation(UPDATE_EMAIL_ADDRESS);
    const [deleteEmailAddress, {error: deleteEmailAddressError}] = useMutation(DELETE_EMAIL_ADDRESS);
    const [createWebHistory] = useMutation(CREATE_WEB_HISTORY);

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const columns = [
        {title: 'Email', field: 'emailAddress', width: '50%'},
        {title: 'Type', field: 'emailAddressType', width: '20%'},
        {title: 'Primary', field: 'primary', type: 'boolean', width: '15%'},
        {title: 'Opted Out', field: 'optedOut', type: 'boolean', width: '15%'},
    ];

    const components = {
        EditField: efprops => {
            if (efprops.columnDef.field === 'emailAddress') {
                let value = emailAddress;
                if (!value && efprops.value) value = efprops.value;
                return (
                    <TextField
                        placeholder="Enter email"
                        autoFocus
                        value={value}
                        style={{fontSize: 16}}
                        className={validateEmail(emailAddress) ? classes.emailOK : classes.emailNotOK}
                        onChange={(e) => {
                            setEmailAddress(e.target.value);
                            return e.target.value;
                        }}
                    />
                )
            } else if (efprops.columnDef.field === 'emailAddressType') {
                let value = efprops.value;
                if (!value && emailAddressType) value = emailAddressType;
                return (
                    <ChooseFromChoices
                        choicesQuery={EMAIL_ADDRESS_TYPE_CHOICES}
                        required={true}
                        value={value}
                        onChange={(newEmailAddressType) => {
                            setEmailAddressType(newEmailAddressType);
                            return newEmailAddressType;
                        }}
                    />
                )
            } else {
                return (<MTableEditField {...efprops} />);
            }
        },
    };

    useEffect(() => {
        if (createEmailAddressError) notify('createEmailAddressError', 'error', createEmailAddressError.message, null, null, globalPersistentState.popupQueryObj);
        if (deleteEmailAddressError) notify('deleteEmailAddressError', 'error', deleteEmailAddressError.message, null, null, globalPersistentState.popupQueryObj);
        if (getEmailAddressesOfParentError) notify('getEmailAddressesOfParentError', 'error', getEmailAddressesOfParentError.message, null, null, globalPersistentState.popupQueryObj);
        if (updateEmailAddressError) notify('updateEmailAddressError', 'error', updateEmailAddressError.message, null, null, globalPersistentState.popupQueryObj);
    }, [createEmailAddressError, deleteEmailAddressError, getEmailAddressesOfParentError, updateEmailAddressError]);

    useEffect(() => {
        getEmailAddressesOfParentRefetch();
    }, [getEmailAddressesOfParentRefetch]);

    useEffect(() => {
    }, [globalLayoutState.editTabBarHeight]);

    const tableCallback = useCallback(node => {
        const addBtn = document.querySelector('button[title="Add"]')
        if (addBtn && globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionText) {
            const email = globalPersistentState.popupQueryObj.selectionText;

            if (email.length > 0) {
                const foundAddresses = emailAddresses.filter(pObj => pObj.emailAddress === email);

                if (foundAddresses.length === 0) {
                    setEmailAddress(email);
                    simulateMouseClick(addBtn);
                }
            }
        }
    }, []);

    useEffect(() => {
        if (getEmailAddressesOfParentData && getEmailAddressesOfParentData.emailAddressesOfParent) {
            let fetchedEmails = [];
            for (let p = 0; p < getEmailAddressesOfParentData.emailAddressesOfParent.length; p++) {
                const emailRec = getEmailAddressesOfParentData.emailAddressesOfParent[p];
                fetchedEmails.push({...emailRec})
            }
            setEmailAddresses(fetchedEmails)
        }
    }, [getEmailAddressesOfParentData]);

    if (getEmailAddressesOfParentLoading) return <p>Loading ...</p>;
    if (getEmailAddressesOfParentError) return `Error! ${getEmailAddressesOfParentError.message}`;

    return (
        <div className={classes.root}>
            {emailAddresses && (
                <div>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            const fudge = 10;

                            const tableOptions = {
                                maxBodyHeight: height - (globalLayoutState.editTabBarHeight + fudge),
                                padding: 'dense',
                                addRowPosition: 'first',
                                header: true,
                                paging: false,
                                showTitle: true,
                                search: false,
                                sorting: true,
                                actionsColumnIndex: -1
                            };

                            return (
                                <div ref={tableCallback} id="email-address-table">
                                    <MaterialTable
                                        icons={tableIcons}
                                        className={classes.table}
                                        title={`Email Addresses ${props.editObj ? 'of ' + props.editObj.displayName : ''}`}
                                        columns={columns}
                                        data={emailAddresses}
                                        options={tableOptions}
                                        components={components}
                                        editable={{
                                            onRowAdd: newData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        if (validateEmail(emailAddress)) {
                                                            let variables = {
                                                                newEmailAddress: {
                                                                    parentType: props.editType,
                                                                    parentId: props.editId,
                                                                    emailAddress: emailAddress,
                                                                    emailAddressType: emailAddressType,
                                                                    primary: (newData.primary === true),
                                                                    optedOut: (newData.optedOut === true),
                                                                }
                                                            };
                                                            if (newData.optedOut) variables.optedOutAt = moment().format();
                                                            createEmailAddress({
                                                                variables: variables
                                                            }).then(async createResult => {
                                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                                    await createWebHistory({
                                                                        variables: {
                                                                            newWebHistory: {
                                                                                parentType: 'emailAddress',
                                                                                parentId: createResult.data.createEmailAddress.id,
                                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                setEmailAddress()
                                                                getEmailAddressesOfParentRefetch();
                                                                resolve();
                                                            }).catch((e) => {
                                                                reject();
                                                            })
                                                        } else {
                                                            reject();
                                                        }
                                                        resolve()
                                                    }, 1000)
                                                }),
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        if (validateEmail(emailAddress)) {
                                                            let variables = {
                                                                changedEmailAddress: {
                                                                    emailAddressId: oldData.emailAddressId,
                                                                    emailAddress: emailAddress,
                                                                    emailAddressType: emailAddressType ? emailAddressType : oldData.emailAddressType,
                                                                    primary: (newData.primary === true),
                                                                    optedOut: (newData.optedOut === true),
                                                                }
                                                            };
                                                            if (newData.optedOut && !oldData.optedOut) variables.optedOutAt = moment().format();
                                                            updateEmailAddress({
                                                                variables: variables
                                                            }).then(async updateResult => {
                                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                                    await createWebHistory({
                                                                        variables: {
                                                                            newWebHistory: {
                                                                                parentType: 'emailAddress',
                                                                                parentId: oldData.emailAddressId,
                                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                setEmailAddress()
                                                                getEmailAddressesOfParentRefetch();
                                                                resolve();
                                                            }).catch((e) => {
                                                                reject();
                                                            })
                                                        } else {
                                                            reject();
                                                        }
                                                        resolve()
                                                    }, 1000)
                                                }),
                                            onRowDelete: oldData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        deleteEmailAddress({
                                                            variables: {
                                                                deleteEmailAddressId: oldData.emailAddressId,
                                                            }
                                                        }).then(() => {
                                                            getEmailAddressesOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000)
                                                }),
                                        }}
                                    />
                                </div>
                            );
                        }}
                    </SizeMe>
                </div>
            )}
        </div>
    )
};

export default PopupEmailAddresses
